import React from 'react';
import { Modal, ModalContent } from '@ids/modal-dialog';

const IRSTaxModal = (props) => {
  return (
    <Modal
      dismissible
      onClose={props.close}
      open={props.open}
      styleOverrideReason="none"
      backdropZIndex={20000}
      size="medium"
    >
      <ModalContent>
        <div className="content-color text-align-left line-height-normal margin-bottom-20px">
          <h1 className="font-size-35px margin-top--30px">
            Changes to IRS mandatory e-filing regulations
          </h1>
          <p className="padding-top-17px padding-bottom-40px">
            Beginning in 2024, all businesses that file 10 or more returns in a calendar year must
            file electronically. Additionally, filers must now combine almost all return types to
            determine the 10-return threshold; this includes 1099 and W-2 filings.
          </p>
          <a
            href="https://www.irs.gov/newsroom/irs-and-treasury-issue-final-regulations-on-e-file-for-businesses"
            rel="noopener noreferrer"
            target="_blank"
            className="learn-more"
          >
            <p>Learn more about the IRS e-filing requirement changes.</p>
          </a>
        </div>
      </ModalContent>
    </Modal>
  );
};
export default IRSTaxModal;
